/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from "clsx";
import { useEffect, useState } from "react";
import { toAbsoluteUrl } from "../../../helpers";
import { getAuth } from "../../../../app/modules/auth";
import axios, { AxiosRequestHeaders } from "axios";
import { formatDistanceToNow, parseISO } from "date-fns";

type Props = {
  module?: string;
  moduleData?: string;
};

interface LogModel {
  url: string;
  status_code: number;
  message: string;
  created_at: string;
  clean_url: string;
  method: string;
}

const HeaderNotificationsMenu: React.FC<Props> = ({ module, moduleData }) => {
  const [logs, setLogs] = useState<LogModel[]>([]);
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiToken = getAuth();
  const token = apiToken?.api_token;

  useEffect(() => {
    if (!module) {
      return;
    }

    const findHeaders: AxiosRequestHeaders = {
      Authorization: `Bearer ${token}`,
      operation: `companies/${module}/find-by-user-id`,
    };

    const loadLogs = async (module: string, headers: AxiosRequestHeaders) => {
      try {
        const response = await axios.get(`${apiUrl}/${module}`, {
          headers,
        });

        // BLINDAGEM 1: Se response.data.logs for undefined, força um array vazio []
        const responseLogs = response?.data?.logs || [];

        setLogs(responseLogs);
      } catch (error) {
        console.error("Erro ao carregar logs:", error);
        // Garante que não quebre caso caia no catch (ex: Erro 400 do Token)
        setLogs([]);
      }
    };

    // AAC-103: só o GET /logs do usuário do token. O socket `events` saiu: não tinha login e
    // mandava a atividade de todos a qualquer conectado.
    loadLogs(module, findHeaders);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const statusClassMap = {
    200: "success",
    201: "success",
    300: "warning",
    400: "warning",
    500: "danger",
  };

  const methodClassMap = {
    POST: "success",
    PUT: "warning",
    PATCH: "info",
    GET: "primary",
    DELETE: "danger",
  };

  return (
    <div
      className="menu menu-sub menu-sub-dropdown menu-column w-375px w-lg-550px "
      data-kt-menu="true"
    >
      <div
        className="d-flex flex-column bgi-no-repeat rounded-top"
        style={{
          backgroundImage: `url('${toAbsoluteUrl(
            "/media/misc/menu-header-bg.jpg",
          )}')`,
          backgroundSize: "cover",
        }}
      >
        <h3 className="text-white fw-bold px-9 mt-10 mb-6">
          Atividades recentes
        </h3>

        <ul className="nav nav-line-tabs nav-line-tabs-2x nav-stretch fw-bold px-9">
          <li className="nav-item">
            <a
              className="nav-link text-white opacity-75 opacity-state-100 pb-4 active"
              data-bs-toggle="tab"
              href="#kt_topbar_notifications_3"
            >
              Logs
            </a>
          </li>
        </ul>
      </div>

      <div className="tab-content">
        <div
          className="tab-pane fade active show"
          id="kt_topbar_notifications_3"
          role="tabpanel"
        >
          <div className="scroll-y mh-325px my-5 px-8" id="logs-list">
            {logs?.map(
              (log, index) =>
                log && (
                  <div
                    key={`log${index}`}
                    className="d-flex flex-stack py-4 row"
                  >
                    <div className="col-2">
                      <span
                        className={clsx(
                          "w-50px badge d-flex justify-content-center",
                          `badge-light-${
                            statusClassMap[
                              (log?.status_code ||
                                "") as keyof typeof statusClassMap
                            ]
                          }`,
                          "me-4",
                        )}
                      >
                        {log.status_code}
                      </span>
                    </div>
                    <div
                      className={clsx(
                        "w-50px badge d-flex justify-content-center col-2",
                        `badge-light-${
                          methodClassMap[
                            log.method as keyof typeof methodClassMap
                          ]
                        }`,
                        "me-4",
                      )}
                    >
                      {log.method}
                    </div>
                    <div className="col-4">
                      <a
                        href="#"
                        className="text-gray-800 text-hover-primary fw-bold"
                      >
                        {log?.status_code?.toString()?.startsWith("2")
                          ? log?.clean_url
                          : log?.message}
                      </a>
                    </div>
                    <div className="col-4">
                      <span className="badge badge-light fs-8">
                        {log && log.created_at
                          ? formatDistanceToNow(parseISO(log.created_at), {
                              addSuffix: true,
                            })
                          : null}
                      </span>
                    </div>
                  </div>
                ),
            )}
          </div>
          {/* <div className="py-3 text-center border-top">
            <Link
              to="/crafted/pages/profile"
              className="btn btn-color-gray-600 btn-active-color-primary"
            >
              View All{" "}
              <KTSVG
                path="/media/icons/duotune/arrows/arr064.svg"
                className="svg-icon-5"
              />
            </Link>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default HeaderNotificationsMenu;
